import { CSSProperties } from "react";
import {
  closeTransition,
  fallbackMaxHeight,
  openTransition,
} from "./NavbarMenuItemSubmenu.constants";
import { SideLayoutType } from "./NavbarMenuItemSubmenu.types";

type ContainerStyleArgs = {
  direction: "down" | "side";
  height: number;
  isClosing: boolean;
  isHovered: boolean;
  sideLayout: SideLayoutType;
  textDirection: "ltr" | "rtl";
  width: number;
};

type ListStyleArgs = {
  direction: "down" | "side";
  sideLayout: SideLayoutType;
};

function createSubmenuContainerStyle({
  direction,
  height,
  isClosing,
  isHovered,
  sideLayout,
  textDirection,
  width,
}: ContainerStyleArgs): CSSProperties {
  const isSideDirection = direction === "side";

  return {
    position: isSideDirection ? "fixed" : "absolute",
    top: direction === "down" ? "var(--navbar-height)" : `${sideLayout.top}px`,
    left: isSideDirection
      ? sideLayout.left === null
        ? "auto"
        : `${sideLayout.left}px`
      : textDirection === "rtl"
        ? "auto"
        : "0",
    right: isSideDirection
      ? sideLayout.right === null
        ? "auto"
        : `${sideLayout.right}px`
      : textDirection === "rtl"
        ? "0"
        : "auto",
    zIndex: "var(--z-index-header-navbar-submenu)",

    height: `${height}px`,
    width: isSideDirection ? `${width}px` : "max-content",
    minWidth: isSideDirection ? "max-content" : "100%",
    opacity: isHovered ? 1 : 0,
    overflow: "hidden",
    transition: isHovered ? openTransition : closeTransition,
    pointerEvents: isHovered || isClosing ? "auto" : "none",

    listStyle: "none",
  };
}

function createSubmenuListStyle({
  direction,
  sideLayout,
}: ListStyleArgs): CSSProperties {
  const isSideDirection = direction === "side";

  return {
    maxHeight: isSideDirection
      ? sideLayout.maxHeight > 0
        ? `${sideLayout.maxHeight}px`
        : fallbackMaxHeight
      : fallbackMaxHeight,
    overflowY: "auto",
    overflowX: "visible",

    backgroundColor: "var(--color-background-navbar-dropdown)",
    listStyle: "none",
    margin: 0,
    padding: 0,
  };
}

export { createSubmenuContainerStyle, createSubmenuListStyle };
